import {
    buildConfigSlice,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import {
    initialSymbolTileConfigState,
    SymbolTileConfigState,
} from './SymbolTileConfigState';
import { selectSymbolTileState } from '../selectors';

export const buildSymbolTileConfigSlice = () =>
    buildConfigSlice<SymbolTileConfigState>(
        WidgetType.SYMBOL_TILE,
        selectSymbolTileState,
        initialSymbolTileConfigState
    );

export const useSymbolTileConfigSlice = () =>
    useConfigSlice(buildSymbolTileConfigSlice());

export type SymbolTileConfigPayloadType =
    WidgetConfigSliceActionPayloadType<SymbolTileConfigState>;
